<template>
  <div class="all-dialog">
    <el-dialog v-dialogDrag :title="title" :visible.sync="visiblePerson" width="950px" :close-on-click-modal="false" :close-on-press-escape="false"
      @closed="closeDialog">
      <el-form ref="formPerson" :model="formPerson" :rules="rules" label-width="100px" size="small">
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="formPerson.name" class="width-335" maxlength="20" show-word-limit placeholder="请输入姓名"
                disabled size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" prop="sex">
              <el-select v-model="formPerson.sex" class="width-335" disabled size="small">
                <el-option v-for="item in sexList" :key="item.id" :label="item.label" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="formPerson.phone" placeholder="请输入手机号" class="width-335" disabled size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="人员类别" prop="isExternal">
              <el-select v-model="formPerson.isExternal" class="width-335" placeholder="请选择" :disabled="type == 1" size="small">
                <el-option v-for="item in iswaioptions" :key="item.id" :label="item.label" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="账号状态" prop="isEnabled">
              <el-select v-model="formPerson.isEnabled" class="width-335" placeholder="请选择" :disabled="type == 1" size="small">
                <el-option v-for="item in isqiyongoptions" :key="item.id" :label="item.label" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <el-button size="small" @click="closePerson">
          取 消
        </el-button>
        <el-button v-if="isEdit" type="primary" size="small" @click="getAddPerson">
          确 定
        </el-button>
      </template>
    </el-dialog>
    <el-dialog v-dialogDrag title="选择部门" :visible.sync="visiblebumen" width="950px" :close-on-click-modal="false" :close-on-press-escape="false"
      @closed="closeDialog1">
      <div style="height:500px">
        <div style="border:1px solid;float: left;width:450px;height:500px;overflow-y: auto;">
          <el-tree :data="datalist" :props="defaultProps" default-expand-all @node-click="handleNodeClick">
            <span slot-scope="{ data }" :title="data.deptName" class="posenlis">
              <i class="el-icon-picture-outline"></i>
              <span style="padding-left: 4px;">{{ data.deptName }}</span>
            </span>
          </el-tree>
        </div>
        <div style="border:1px solid;float: right;width:450px;height:500px;overflow-y: auto;">
          <ul>
            <li v-for="(item, index) in deptlist" :key="index" style="padding-left:15px;height:25px;line-height:25px"
              :title="item.fullDeptName" @click="delbumen(item)">
              {{ item.deptName }}
            </li>
          </ul>
        </div>
      </div>
      <template #footer>
        <el-button size="small" @click="visiblebumen = false">
          取 消
        </el-button>
        <el-button type="primary" size="small" @click="getAddbumen">
          确 定
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import systemPersonService from "@/CommonDP/service/enterprisePerson-service";
const newPerson = (data) => {
  const p = {
    username: "",
    name: "",
    staffID: "",
    isCome: 0,
    sex: "",
    nativePlace: "",
    nation: "",
    birthDay: "",
    phone: "",
    idCard: "",
    postName: "",
    isUse: 1,
    depName: "",
    remark: "",
    ...data
  };
  return p;
};
export default {
  name: "AddPerson",
  data() {
    var validatephone = (rule, value, callback) => {
      var idCardx = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (value.length > 11) {
        callback(new Error("手机号不得超过11位"));
      } else if (!idCardx.test(value)) {
        if (this.type === 2) {
          callback();
        } else {
          callback(new Error("请输入正确的手机号"));
        }
      } else {
        callback();
      }
    };
    return {
      type: 0, // 0 添加 1查看 2 修改
      rules: {
        username: [{ required: true, message: "请输入登录名", trigger: "blur" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        isUse: [{ required: true, message: "请选择在职状态", trigger: "blur" }],
        phone: [{ required: true, validator: validatephone, trigger: "blur" }]
      },
      visiblePerson: false,
      formPerson: newPerson(),
      sexList: [
        { id: "男", label: "男" },
        { id: "女", label: "女" }
      ],
      iswaioptions: [
        { id: 1, label: "外部" },
        { id: 0, label: "内部" }
      ],
      isqiyongoptions: [
        { id: 1, label: "启用" },
        { id: 0, label: "禁用" }
      ],
      visiblebumen: false,
      defaultProps: {
        children: "children",
        label: "deptName"
      },
      datalist: [],
      deptlist: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo
    }),
    isEdit() {
      return this.type === 0 || this.type === 2;
    },
    checkInuser() {
      return this.formPerson.checkInuser || (this.type === 0 ? this.userInfo.name : "");
    },
    title() {
      return ["添加人员", "查看人员", "修改人员"][this.type];
    }
  },
  created() {
    this.formPerson = newPerson();
  },
  methods: {
    handleNodeClick(data) {
      this.deptlist.push(data);
      for (var i = this.deptlist.length - 1; i >= 0; i--) {
        if (this.deptlist.indexOf(this.deptlist[i]) !== this.deptlist.lastIndexOf(this.deptlist[i])) {
          this.deptlist.splice(i, 1);
        }
      }
    },
    delbumen(data) {
      for (var u = 0; u < this.deptlist.length; u++) {
        if (data.deptId == this.deptlist[u].deptId) {
          this.deptlist.splice(u, 1);
        }
      }
    },
    // 添加人员
    async getAddPerson() {
      const { enterpriseId, enterpriseUserId, isEnabled, isExternal } = this.formPerson;
      const params = { enterpriseId, isEnabled, isExternal, enterpriseUserId };
      await this.$refs.formPerson.validate();
      console.log(params, "params");
      switch (this.type) {
        case 0:
          await systemPersonService.newAddPerson(params);
          break;
        case 2:
          await systemPersonService.newEditPerson(params);
          break;

        default:
          return;
      }
      this.getRefresh();
      this.visiblePerson = false;
      if (this.type == 2) {
        this.$message({
          showClose: true,
          type: "success",
          message: "修改成功"
        });
      } else {
        this.$message({
          showClose: true,
          type: "success",
          message: "添加成功"
        });
      }
    },
    setPersonInfo(info, type = 0) {
      this.type = type;
      this.formPerson = newPerson(info);
      this.formPerson.deptList1 = "";
      this.formPerson.deptListtit1 = "";
      this.formPerson.deptList2 = "";
      this.formPerson.deptListtit2 = "";
      for (var i = 0; i < this.formPerson.deptList.length; i++) {
        if (this.formPerson.deptList[i].isMain === null) {
          this.formPerson.deptList1 += this.formPerson.deptList[i].deptName + "、";
          this.formPerson.deptListtit1 += this.formPerson.deptList[i].fullDeptName + "、";
        }
      }
      for (var i = 0; i < this.formPerson.deptList.length; i++) {
        if (this.formPerson.deptList[i].isMain === 1) {
          this.formPerson.deptList2 += this.formPerson.deptList[i].deptName + "、";
          this.formPerson.deptListtit2 += this.formPerson.deptList[i].fullDeptName + "、";
        }
      }
      console.log(this.formPerson, "this.formPerson");
      this.visiblePerson = true;
    },
    getRefresh() {
      this.$emit("getfreshen");
    },
    closeDialog() {
      this.type = 0;
      this.formPerson = newPerson();
      this.$refs.formPerson.clearValidate();
    },
    closeDialog1() {
      this.visiblebumen = false;
    },
    closePerson() {
      this.visiblePerson = false;
    },
    getAddbumen() {}
  }
};
</script>
<style lang="scss" scoped>
.width-200 {
  width: 220px;
}
.width-335 {
  width: 335px;
}
.all-dialog {
  h4 {
    line-height: 20px;
    font-size: 14px;
    color: #fff;
    padding-left: 10px;
    margin-top: 5px;
    background-color: rgb(170, 165, 165);
    margin-bottom: 10px;
  }
  .el-form{
    margin: 30px 0 15px 0;
  }
}
.footer-dialog {
  margin-left: 100px;
}
</style>
